$(function(){
	var accord = $('.expanding-list');
	accord.each(function(){
		var dt = $(this).children('dt'),
			dd = $(this).children('dd');
		dt.click(function(){
			if($(this).hasClass('active')){
				$(this).removeClass('active').next('dd').removeClass("visible");
				animScroll(scrolld + dt.first().offset().top,0)
			} else{
				$(this).addClass('active').siblings('dt').removeClass('active');
				$(this).next('dd').addClass("visible").siblings('dd').removeClass("visible");

				var index = $(this).index() / 2;
				animScroll($("dd").eq(index).offset().top + $("body").scrollTop() - 120)
			}
		});
	});
});